import { _ as _objectSpread2 } from '../_rollupPluginBabelHelpers.js';

var borders = function borders(overrides) {
  return _objectSpread2({
    default: {
      color: 'white800',
      style: 'solid',
      width: '1px'
    }
  }, overrides);
};

export default borders;